export async function addSpaceDelegation(params) {
    const { spaceDapp, smartAccount, fnArgs } = params;
    const { spaceId, operatorAddress, signer } = fnArgs;
    if (!spaceDapp) {
        throw new Error('spaceDapp is required for addSpaceDelegation operation.');
    }
    const space = spaceDapp.getSpace(fnArgs.spaceId);
    if (!space) {
        throw new Error(`Space with spaceId "${spaceId}" is not found.`);
    }
    const toAddress = spaceDapp.config.addresses.baseRegistry;
    return spaceDapp.addSpaceDelegation({
        operatorAddress,
        spaceId,
        signer,
        overrideExecution: async ({ calldata: callData }) => {
            if (typeof callData !== 'string') {
                throw new Error('calldata is not a string');
            }
            return smartAccount.sendUserOp({
                toAddress,
                callData,
                signer,
                spaceId,
                functionHashForPaymasterProxy: 'unsponsored',
            });
        },
    });
}
